"use strict";var t=require("@apollo/client"),e=t.gql`
  fragment PricePerBaseUnit on ProductPrice {
    taxes
    totalBeforeTaxes
    subtotal
    fullPrice
    discount
    total
    taxesSummary {
      id
      name
      value
      type
      rate
    }
  }
`,a=t.gql`
  fragment Substitutes on Substitutes {
    substituteMode
    substituteProducts
  }
`,i=t.gql`
  ${a}
  ${e}
  fragment CartProduct on CartProductModel {
    id
    name
    unitQuantity
    baseUnitPrice
    reference
    unit
    baseUnit
    variant
    instruction
    price {
      ...PricePerBaseUnit
    }
    imageUrl
    minUnitQuantity
    maxUnitQuantity
    createdAt
    updatedAt
    status
    substitutes {
      ...Substitutes
    }
  }
`,r=t.gql`
  fragment CartSpecialProduct on CartSpecialProductModel {
    id
    unitQuantity
    unit
    instruction
    imageUrl
    sku
    price {
      subtotal
      discount
      total
    }
    name
    status
    createdAt
    updatedAt
  }
`,u=t.gql`
  fragment validationIssue on ValidationIssue {
    reason
    productId
    type
  }
`;exports.C=i,exports.P=e,exports.S=a,exports.V=u,exports.a=r;